import {NgModule} from '@angular/core';
import {L10nModule} from '../../../../components/translate';
import {RefreshButtonComponent} from './refresh-button.component';

@NgModule({
    imports: [
        L10nModule
    ],
    declarations: [
        RefreshButtonComponent
    ],
    exports: [
        RefreshButtonComponent
    ]
})
export class RefreshButtonModule {}
